export enum Role {
  Customer = 'Customer',
  CustomerSupportRep = 'CSR',
  Admin = 'Admin',
  Sales = 'Sales',
  DealerSupportRep = 'DealerSupportRep',
  Company = 'Company',
  Group = 'Group',
  Store = 'Store',
  CSR = 'CSR',
  RapidSystem = 'RapidSystem',
  CSRManager = 'CSRManager',
  Trainer = 'Trainer',
  Farmer = 'Farmer',
  TrainingStore = 'TrainingStore',
  Storis = 'Storis',
}

export const merchantRoles: Role[] = [Role.Company, Role.Group, Role.Store, Role.Storis];
export const koalafiRoles: Role[] = [Role.CustomerSupportRep, Role.Admin, Role.DealerSupportRep, Role.CSR, Role.CSRManager];
